export default {
    Success: 'Success',
    Unauthorised: 'Unauthorised',
    Forbidden: 'Forbidden',
    BadRequest: 'BadRequest',
    Conflict: 'Conflict',
    NotFound: 'NotFound',
    UnknownError: 'UnknownError',
} as const
